import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import LegalConsentModal from '../LegalConsentModal/LegalConsentModal';
import legalPolaroidImage from '../../assets/legal_polaroid.png';
import { useAppContext } from '../../context/AppContext';

// Styled Components

const WidgetContent = styled.div`
  background: white;
  flex: 1;
  overflow-y: auto;
`;

// Full page container - no floating button needed
const FullPageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: white;
`;



interface WidgetContainerProps {
  children: React.ReactNode;
  title?: string;
}

const WidgetContainer: React.FC<WidgetContainerProps> = ({
  children
}) => {
  const { state } = useAppContext();
  const location = useLocation();
  const [showConsent, setShowConsent] = React.useState(false);

  React.useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('FASHION_CONNECT_LEGAL_CONSENT');

    // Define public paths where modal should NOT block (e.g., legal pages, error)
    const publicPaths = [
      '/kvkk-aydinlatma-metni',
      '/acik-riza-metni',
      '/kullanim-kosullari',
      '/fash-size',
      '/error'
    ];

    const isPublicPath = publicPaths.some(path => location.pathname.startsWith(path));

    const isDemoMode = state.demoMode || (new URLSearchParams(window.location.search).get('demoMode') === 'true');

    // Show consent globally if not consented, not on a public page, and NOT in demo mode
    if (!hasConsented && !isPublicPath && !isDemoMode) {
      setShowConsent(true);
    } else {
      setShowConsent(false);
    }
  }, [location, state.demoMode]);

  const handleConsent = () => {
    localStorage.setItem('FASHION_CONNECT_LEGAL_CONSENT', 'true');
    setShowConsent(false);
  };

  // Full page layout - always visible, no overlay
  return (
    <FullPageContainer>
      <WidgetContent>
        {children}
      </WidgetContent>
      <LegalConsentModal
        isOpen={showConsent}
        onAccept={handleConsent}
        imageUrl={legalPolaroidImage}
      />
    </FullPageContainer>
  );
};

export default WidgetContainer;
